const RightSideGroupArrowIcon = ({ className }: { className?: string }) => {
  return (
    <div className={className}>
      <svg
        width={"1em"}
        height={"1em"}
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          width={"1em"}
          height={"1em"}
          rx="11"
          transform="matrix(-1 0 0 1 22 0)"
          fill="#455468"
        />
        <path
          d="M15 15.3662L11.6533 11.1828L15 6.99935"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.98047 15.3662L6.63372 11.1828L9.98047 6.99935"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

export default RightSideGroupArrowIcon;
